module.exports = __webpack_public_path__ + "img/jcb.bdcf552.png";